import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/page-navigation/lib/styles/index.css'
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

export const RecordKeeperContentView = ({
  signURL,
  fileName,
  extension,
  cssStyle,
  customClassNames,
}: {
  signURL: string
  fileName: string
  extension: string
  cssStyle?: boolean
  customClassNames?: string
}) => {
  console.log(extension, 'extension', signURL);
  const [videoError, setVideoError] = useState(false)
  const [hasPreviewError, setHasPreviewError] = useState(false)
  const getFileType = () => {
    if (['jpg', 'jpeg', 'png', 'svg', 'webp'].includes(extension)) {
      return 'image'
    } else if (extension === 'pdf') {
      return 'pdf'
    } else if (['ppt', 'pptx', 'docx', 'doc', 'xlsx', 'xls', 'csv'].includes(extension)) {
      return 'all'
    } else if (['mp4', 'mov', 'avi', 'wmv', 'flv', 'webm', 'mkv'].includes(extension)) {
      return 'video'
    } else if (['txt', 'text'].includes(extension)) {
      return 'text'
    } else if (
      ['mp3', 'wav', 'flac', 'aac', 'wma', 'm4a', 'ogg', 'aiff', 'midi', 'midi', 'midi', "mp4a", "m4a"].includes(
        extension
      )
    ) {
      return 'audio'
    }
    return 'unknown'
  }
  // useEffect(() => {
  //   const handleKeyDown = (e: any) => {
  //     if (e.key === 'ArrowRight') {
  //       jumpToNextPage()
  //     } else if (e.key === 'ArrowLeft') {
  //       jumpToPreviousPage()
  //     }
  //   }
  //   document.addEventListener('keydown', handleKeyDown)
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyDown)
  //   }
  // }, [jumpToNextPage, jumpToPreviousPage]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    setHasPreviewError(false)
  }, [signURL])
  const { formatMessage } = useIntl()
  return (
    <>
      {(() => {
        const fileType = getFileType()
        console.log(fileType, 'fileType');
        if (fileType === 'pdf') {
          return (
            <div
              style={{
                border: 'none',
                boxShadow: '',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
              }}
              className={clsx(customClassNames)}
            >
              <iframe
                src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                  signURL
                )}&embedded=true`}
                width='100%'
                height='100%'
                style={{ border: 'none' }}
                title={fileName}
                onError={() => setHasPreviewError(true)}
              ></iframe>
              {hasPreviewError && (
                <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                  <h1>{formatMessage({ id: 'Preview Not Available' })}</h1>
                </div>
              )}
            </div>
          )
        } else if (fileType === 'image') {
          return (
            <div
              style={{
                height: cssStyle ? '' : '92vh',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              <div
                className={clsx('image-container', customClassNames)}
                style={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                  overflow: 'hidden',
                  margin: 'auto',
                }}
              >
                <img
                  src={signURL}
                  alt={fileName}
                  style={{
                    width: '100%',
                    height: '93vh',
                    objectFit: 'contain',
                  }}
                  onError={() => setHasPreviewError(true)}
                />
                {hasPreviewError && (
                  <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                    <h1>{formatMessage({ id: 'Preview Not Available' })}</h1>
                  </div>
                )}
              </div>
            </div>
          )
        } else if (fileType === 'all') {
          return (
            <div className={clsx('iframe-container', customClassNames)}>
              <iframe
                width='100%'
                height='100%'
                title='Embedded Document'
                src={`https://docs.google.com/gview?url=${encodeURIComponent(signURL).replace(
                  /'/g,
                  '%27'
                )}&embedded=true`}
              ></iframe>
            </div>
          )
        } else if (fileType === 'video') {
          return (
            <div
              className={clsx(
                'iframe-container ',
                customClassNames
              )}
            >
              {!videoError ? (
                <video
                  src={signURL}
                  width='100%'
                  height='100%'
                  controls
                  autoPlay
                  onError={() => setVideoError(true)}
                >
                  <source src={signURL} type={`video/${fileName.split('.').pop()}`} />
                </video>
              ) : (
                <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                  <h1>{formatMessage({ id: 'Preview Not Available' })}</h1>
                </div>
              )}
            </div>
          )
        } else if (fileType === 'audio') {
          return (
            <div
              className={clsx(
                'iframe-container w-100 d-flex justify-content-center h-100 align-items-center',
                customClassNames
              )}
            >
              <audio controls autoPlay onError={() => setHasPreviewError(true)}>
                <source src={signURL} type={`audio/${fileName.split('.').pop()}`} />
              </audio>
              {hasPreviewError && (
                <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                  <h1>{formatMessage({ id: 'Preview Not Available' })}</h1>
                </div>
              )}
            </div>
          )
        } else if (fileType === 'text') {
          return (
            <div
              className={clsx(
                'text-container w-100 h-100 align-items-center',
                customClassNames
              )}
            >
              <iframe
                src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                  signURL
                )}&embedded=true`}
                width='100%'
                height='100%'
                style={{ border: 'none' }}
                title={fileName}
              ></iframe>
            </div>
          )
        } else {
          return (
            <h1 className='w-100 h-100 d-flex justify-content-center align-items-center'>
              {formatMessage({ id: 'Preview Not Available' })}
            </h1>
          )
        }
      })()}
    </>
  )
}